import type { BankRate } from "web_myplann/Calculators/Types/BankRate";
import type { MortgageRateResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { matchesMortgageRate } from "web_myplann/Shared/Utils/matchesMortgageRate";

export const findBankRates = (
	ltv: number,
	loanValue: number,
	years: number,
	rates: MortgageRateResponseDTO[],
): BankRate[] => {
	const byBank = new Map<number, BankRate>();

	for (const rate of rates) {
		if (matchesMortgageRate(rate, { ltv, amount: loanValue, years })) {
			byBank.set(rate.bankId, {
				bankId: rate.bankId,
				status: "ok",
				rate: rate.rate,
			});
			continue;
		}

		if (!byBank.has(rate.bankId)) {
			byBank.set(rate.bankId, {
				bankId: rate.bankId,
				status: "fail",
				rate: rate.rate,
			});
		}
	}

	return [...byBank.values()].sort((a, b) => a.bankId - b.bankId);
};
